//Filename ./src/index.js
// Import resources
import React from 'react';
import ReactDOM from 'react-dom';
import App from 'apa/containers/App';

// Import bootstrap css
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './apa/style/index.scss';
import {IntlProvider} from 'react-intl';
import Cookie from 'js-cookie';
import 'reactstrap/dist/reactstrap.full.min';
const DEFAULT_LOCALE = 'de';

const locale = Cookie.get('locale') || DEFAULT_LOCALE;

import {addLocaleData} from 'react-intl';
import de from 'react-intl/locale-data/de';

import '@fortawesome/fontawesome-free/js/all'

addLocaleData([...de]);

// Render main app
ReactDOM.render(
    <IntlProvider locale={locale} defaultLocale={DEFAULT_LOCALE}>
        <App/>
    </IntlProvider>,
    document.getElementById('app')
);

